import DirHandler from "../../../Utils/dir";

import type {
  BaseWorkspaceRepository,
  CreateWorkspaceRequest,
  CreateWorkspaceResponse,
  SelectWorkspaceResponse,
  WorkspaceList,
} from "./BaseWorkspaceRepository.interface";

class ExperimentalWorkspaceRepository implements BaseWorkspaceRepository {
  async select(): Promise<SelectWorkspaceResponse> {
    try {
      await DirHandler.openDir();

      return {
        error: true,

        message:
          "Workspace selection not fully implemented in experimental mode",
      };
    } catch (e) {
      console.error(e);

      return {
        error: true,

        message: "Error selecting workspace",
      };
    }
  }

  async getCurrent(): Promise<string> {
    try {
      const rootDirName = await DirHandler.getRootDirName();

      if (typeof rootDirName === "string") {
        return rootDirName;
      }

      return rootDirName;
    } catch (e) {
      console.error(e);

      return "";
    }
  }

  async create(workspace: CreateWorkspaceRequest): Promise<{
    error: boolean;

    message: string;

    data?: CreateWorkspaceResponse;
  }> {
    try {
      const mockResponse: CreateWorkspaceResponse = {
        id: Date.now(),

        name: workspace.name || "Workspace Experimental",

        path: workspace.path,

        description: workspace.description || null,

        logo: typeof workspace.logo === "string" ? workspace.logo : null,

        cover: typeof workspace.cover === "string" ? workspace.cover : null,

        isPublic: workspace.isPublic ?? false,

        created_at: new Date().toISOString(),

        userId: null,

        selected: workspace.selected ?? false,
      };

      return {
        error: false,

        message: "Workspace created successfully (experimental mode)",

        data: mockResponse,
      };
    } catch (e) {
      console.error(e);

      return {
        error: true,

        message: "Error creating workspace in experimental mode",
      };
    }
  }

  async getAll(): Promise<WorkspaceList | null> {
    try {
      return [];
    } catch (e) {
      console.error(e);

      return null;
    }
  }

  async readFile(directory: string, fileName: string) {
    const result = await DirHandler.readFile(directory, fileName);

    return result.content;
  }

  async delete(
    workspaceId: string,
  ): Promise<{ error: boolean; message: string }> {
    try {
      console.log("Experimental delete workspace:", workspaceId);

      return {
        error: false,

        message: "Workspace deleted successfully (experimental mode)",
      };
    } catch (e) {
      console.error(e);

      return {
        error: true,

        message: "Error deleting workspace in experimental mode",
      };
    }
  }

  async import(path: string): Promise<{
    error: boolean;

    message: string;

    code?: string;

    data?: CreateWorkspaceResponse;
  }> {
    try {
      console.log("Experimental import workspace:", path);

      const mockResponse: CreateWorkspaceResponse = {
        id: Date.now(),

        name: "Imported Workspace",

        path: path,

        description: null,

        logo: null,

        cover: null,

        isPublic: false,

        created_at: new Date().toISOString(),

        userId: null,

        selected: false,
      };

      return {
        error: false,

        message: "Workspace imported successfully (experimental mode)",

        data: mockResponse,
      };
    } catch (e) {
      console.error(e);

      return {
        error: true,

        message: "Error importing workspace in experimental mode",
      };
    }
  }

  async unselect(): Promise<{ error: boolean; message: string }> {
    try {
      console.log("Experimental unselect all workspaces");

      return {
        error: false,

        message: "All workspaces unselected successfully (experimental mode)",
      };
    } catch (e) {
      console.error(e);

      return {
        error: true,

        message: "Error unselecting workspaces in experimental mode",
      };
    }
  }
}

export default ExperimentalWorkspaceRepository;
